import { render, staticRenderFns } from "./messageTemplateEditDialog.vue?vue&type=template&id=45ec6fd9&"
import script from "./messageTemplateEditDialog.vue?vue&type=script&lang=js&"
export * from "./messageTemplateEditDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports